/* eslint-disable no-use-before-define */
import qs from 'qs';
import { camelCase, kebabCase, join as loJoin, take, takeRight } from 'lodash';

export const urls = {
  crew: crew => `/installers/${crew.installer_id}`,
  schedule: date => `/schedule${date ? date.format('/Y/MM/DD') : ''}`,
  ...resource('phase', {
    members: ['info', 'history', 'labor-product-accounting', 'cv-checklist',
      'scheduling-checklist', 'appointments', 'warehouse-materials', 'communications',
      'materials-checklist', 'ifi-template'],
  }),
  appointment: appointment => `/phases/${appointment.phase.id}/appointments#appointment${appointment.id}`,
  newAppointment: (phaseId, apptType) => `/phases/${phaseId}/appointments/new/${apptType}`,
  ...resource('estimator'),
  ...resource('iqm'),
  ...resource('installer'),
  ...resource('store'),
  ...resource('employee'),
  ...resource('workroom'),
  phaseWarehouseMaterials: phaseId => `/phases/${phaseId}/warehouse-materials`,
  phasePurchaseOrders: phaseId => `/phases/${phaseId}/labor-product-accounting`,
  workroomFromPhaseDetails: workroomID => `/workrooms/${workroomID}`,
  warehouseReport: () => '/reports/warehouse',
  installWorkorderReport: () => '/reports/install-workorder',
  installerPaperwork: () => '/reports/installer-paperwork',
  jobHistory: () => '/reports/job-history',
  activity: () => '/reports/activity',
  tags: () => '/reports/tags-report',
  scraper: () => '/tools/scraper',
  help: () => 'https://serviceprosig.zendesk.com/hc/en-us',
  releaseNotes: () => 'https://serviceprosig.zendesk.com/hc/en-us/sections/115001703648-Release-Updates',
  lowesItem: itemId => `https://www.lowes.com/search?searchTerm=${itemId}`,
  filtersHelp: () => 'https://serviceprosig.zendesk.com/hc/en-us/articles/115005917228-SPOT-Basics-Part-5-Dashboard-Filtering',
};

export function linkTo(object) {
  if (!object.kind) return null;
  const helperName = camelCase(object.kind);
  if (!urls[helperName]) return null;
  return urls[helperName](object);
}

function join(...args) { return loJoin(args, '/'); }

function url(path, opts = null) {
  if (!opts) return path;
  let pathname = path;
  const options = { ...opts };
  if (options.query) {
    pathname += `?${qs.stringify(options.query)}`;
    delete options.query;
  }
  return Object.keys(options).length ? { pathname, ...options } : pathname;
}

function resource(resourceName, options = {}) {
  const pluralResource = `${resourceName}s`;
  const resourceUrl = `/${kebabCase(pluralResource)}`;
  const resourceUrls = {
    [pluralResource]: () => resourceUrl,
    [camelCase(`create ${resourceName}`)]: () => join(resourceUrl, 'new'),
    [resourceName]: object => join(resourceUrl, object.id),
    [camelCase(`update ${resourceName}`)]: object => join(resourceUrl, object.id, 'edit'),
    ...(options.resourceUrls || {}),
  };

  if (options.members) {
    options.members.forEach((m) => {
      resourceUrls[camelCase(`${resourceName} ${m}`)] = object =>
        join(resourceUrls[resourceName](object), m);
    });
  }
  return resourceUrls;
}

Object.keys(urls).forEach((k) => {
  const f = urls[k];
  urls[k] = (...args) =>
    url(f(...take(args, f.length)), ...takeRight(args, args.length - f.length));
});



// WEBPACK FOOTER //
// ./client/app/shared/helpers/url.js